import React, { useState, useEffect } from "react";
import "../profiles/Profiles";
import "./beneficiary.css";
import { useTranslation } from "react-i18next";
import { Button, Spinner, Card, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { apiRequest } from "../../services";
import { toast } from "react-toastify";
import { motion, AnimatePresence } from "framer-motion";
import {
  PersonAdd,
  PersonVcard,
  Wallet2,
  ClockHistory,
  Bullseye,
  CurrencyExchange,
  GraphUpArrow,
  PiggyBank,
  CashCoin,
  ArrowRightCircle,
} from "react-bootstrap-icons";

const Beneficiary = () => {
  const userData = useSelector((state) => state.users);
  const [loading, setLoading] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleNavigateAccount = (account) => {
    console.log("ACCOUNT  data selected", account)
    navigate(`/mon-compte`, {
      state: { account: account },
    });
  };

  const handleNavigate = (accountId, accountName) => {
    navigate(`/addBeneficiary`, {
      state: { accountId: accountId, accountName: accountName },
    });
  };

  const getAllClientAccountByInsuranceCode = async () => {
    try {
      setLoading(true);
      const requestData = {
        serviceReference: "GET_ALL_ACCOUNT_CLIENT",
        requestBody: userData.users.clientDetails.phoneNumber,
      };

      console.log("GATEWAY log", userData)
      console.log("GATEWAY logToken", userData.token)
      const response = await apiRequest(
        "GATEWAY",
        "",
        "POST",
        requestData,
        userData.token,
        dispatch,
        navigate
      );

      if (response && response.status === 200) {
        setAccounts(response.body.data);
      } else {
        toast.error("Une erreur est survenue");
      }
    } catch (error) {
      toast.error(error.message || "Erreur de connexion");
    }
    setLoading(false);
  };

  useEffect(() => {
    getAllClientAccountByInsuranceCode();
  }, []);

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        when: "beforeChildren",
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 1 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 10,
      },
    },
  };

  const cardHoverEffect = {
    scale: 1.02,
    boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
    transition: {
      duration: 0.3,
      ease: "easeInOut",
    },
  };

  return (
    <div className="beneficiary-container">
      {/* Hero Section */}
      <motion.div
        className="beneficiary"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="overlay-text">
          <motion.h1
            initial={{ y: -20 }}
            animate={{ y: 0 }}
            transition={{ duration: 0.5 }}
          >
            {t("titleEpargne")}
          </motion.h1>
        </div>
      </motion.div>

      {/* Main Content */}
      <div className="container py-5">
        {/* Header */}
        <motion.div
          className="p-4 mb-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <div className="d-flex justify-content-between flex-wrap align-items-center">
            <div className="d-flex align-items-center">
              <Wallet2 size={28} className="me-3 text-primary" />
              <h2 className="mb-0">
                {t("sousTitleEpargne")}{" "}
                <span className="insurance-code">
                  ({userData?.users?.clientDetails?.clientId})
                </span>
              </h2>
            </div>
            <div
              className="action-buttons-container"
              style={{ marginTop: "2rem" }}
            >
              <Button
                variant="primary"
                className="beneficiary-action-button"
                onClick={() => navigate("/profiles")}
              >
                <ArrowRightCircle className="me-2" />
                {t("completeSubscription")}
              </Button>
              <Button
                variant="success"
                className="beneficiary-action-button"
                onClick={() => navigate("/declaration")}
              >
                <GraphUpArrow className="me-2" />
                {t("declaration")}
              </Button>
            </div>
          </div>
        </motion.div>

        {/* Accounts Grid */}
        {loading ? (
          <motion.div
            className="text-center py-5"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <Spinner animation="border" variant="primary" role="status">
              <span className="visually-hidden">
                {t("Chargement des comptes...")}
              </span>
            </Spinner>
            <p className="mt-3">{t("Chargement des comptes...")}</p>
          </motion.div>
        ) : accounts.length === 0 ? (
          <motion.div
            className="text-center py-5"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <PiggyBank size={48} className="text-muted mb-3" />
            <h4>{t("Aucun plan d'épargne trouvé.")}</h4>
            <p className="text-muted">
              {t("Commencez par créer un nouveau plan d'épargne.")}
            </p>
          </motion.div>
        ) : (
          <motion.div
            className="row g-4"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            <AnimatePresence>
              {accounts && accounts.map((account) => (
                <motion.div
                  className="col-md-6 col-lg-4"
                  key={account.accountId}
                  variants={itemVariants}
                  layout
                >
                  <motion.div
                    className="card-beneficiare h-100"
                    whileHover={cardHoverEffect}
                  >
                    <Card.Body className="d-flex flex-column h-100">
                      <div className="d-flex align-items-center mb-3">
                        {account.savingPlanDescription?.includes(
                          "FREESAVING"
                        ) ? (
                          <PiggyBank size={24} className="me-2 text-warning" />
                        ) : (
                          <CashCoin size={24} className="me-2 text-success" />
                        )}
                        <Card.Title className="mb-0">
                          {account.savingPlanDescription}
                        </Card.Title>
                      </div>

                      <div className="flex-grow-1">
                        {account.savingPlanDescription?.includes(
                          "FREESAVING"
                        ) ? (
                          <>
                            <div className="info-item-account mb-3">
                              <div className="d-flex align-items-center text-muted">
                                <ClockHistory size={16} className="me-2" />
                                <small>{t("amountFrequency")}</small>
                              </div>
                              <p className="mb-0">{t("notFrequence")}</p>
                            </div>
                            <div className="info-item-account mb-3">
                              <div className="d-flex align-items-center text-muted">
                                <CurrencyExchange size={16} className="me-2" />
                                <small>{t("balance")}</small>
                              </div>
                              <p className="balance mb-0">
                                {account.balance + account.cumulativeInterest} FCFA
                              </p>
                            </div>
                            <div className="info-item-account">
                              <div className="d-flex align-items-center text-muted">
                                <Bullseye size={16} className="me-2" />
                                <small>{t("amountCible")}</small>
                              </div>
                              <p className="mb-0">{t("notObjectif")}</p>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="info-item-account mb-3">
                              <div className="d-flex align-items-center text-muted">
                                <ClockHistory size={16} className="me-2" />
                                <small>{t("amountFrequency")}</small>
                              </div>
                              <p className="mb-0">
                                {account.savingFrequencyAmount} FCFA /{" "}
                                {account.savingFrequency} {t("days")}
                              </p>
                            </div>
                            <div className="info-item-account mb-3">
                              <div className="d-flex align-items-center text-muted">
                                <CurrencyExchange size={16} className="me-2" />
                                <small>{t("balance")}</small>
                              </div>
                              <p className="balance mb-0">
                                {account.balance} FCFA
                              </p>
                            </div>
                            <div className="info-item-account">
                              <div className="d-flex align-items-center text-muted">
                                <Bullseye size={16} className="me-2" />
                                <small>{t("amountCible")}</small>
                              </div>
                              <p className="cible mb-0">
                                {account.targetAmount} FCFA
                              </p>
                            </div>
                          </>
                        )}
                      </div>

                      <div className="mt-auto pt-3 d-flex gap-2">
                        {/* <Button
                          variant="primary"
                          size="sm"
                          className="action-button d-flex align-items-center"
                          disabled={account.associatedWithAAsured}
                          onClick={() =>
                            handleNavigate(
                              account.accountId,
                              account.savingPlanDescription
                            )
                          }
                        >
                          <PersonAdd className="me-2" />
                          {t("Ajouter Assurer")}
                        </Button> */}
                        <Button
                          variant="primary"
                          size="sm"
                          className="action-button d-flex align-items-center"
                          onClick={() => handleNavigateAccount(account)}
                        >
                          <PersonVcard className="me-2" />
                          {t("Consulter")}
                        </Button>
                      </div>
                    </Card.Body>
                  </motion.div>
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default Beneficiary;
